<!-- <nav class="sidebar shadow-sm" [ngClass]="{ collapsed: isCollapsed }">
<div class="flex flex-col justify-between h-full">
  <div>
    <ul>
      <ng-container *ngFor="let item of navItems">
        <li class="sidebar-item !text-grey-dark" @if="showMenu(item)">
          <a
            [routerLink]="'/' + item.link"
            routerLinkActive="active"
            [id]="item.label + 'link'"
            class="flex items-center h-[47px]"
            >
            <i
              [sch-icon]="item.icon"
              class="icon !text-2xl !font-semibold"
            ></i>
            <span class="ms-2" @if="!isCollapsed">
              {{ item.label | titlecase }}
            </span>
          </a>
        </li>
      </ng-container>

      <div class="border-t border-t-grey-light mt-3 py-3">
        <ng-container *ngFor="let item of navItems2">
          <li class="sidebar-item !text-grey-dark" @if="showMenu(item)">
            <a
              [routerLink]="'/' + item.link"
              routerLinkActive="active"
              [id]="item.label + 'link'"
              class="flex items-center h-[47px]"
              >
              <i
                [sch-icon]="item.icon"
                class="icon !text-2xl !font-semibold"
              ></i>
              <span class="ms-2" @if="!isCollapsed">
                {{ item.label | titlecase }}
              </span>
            </a>
          </li>
        </ng-container>
      </div>
    </ul>
  </div>

  <div class="flex items-center justify-end py-3 pr-3">
    <i
      [sch-icon]="'prev-arrow'"
      class="text-primary border border-primary rounded-full h-7 w-7 text-lg flex items-center justify-center cursor-pointer"
      (click)="toggleSidebar()"
    ></i>
  </div>
</div>
</nav> -->

<nav
  class="sidebar shadow-sm lg:block hidden"
  [ngClass]="{ collapsed: isCollapsed }"
>
  <div class="sidebar-column flex flex-col justify-between h-full">
    <div class="sidebar-list">
      <ul>
        @for (
          navItemGroup of navItems;
          track navItemGroup;
          let isFirst = $first
        ) {
          @if (!isFirst && navItemGroup.length > 0) {
            <div class="border-t border-t-grey-light mt-2 pb-2"></div>
          }
          <!-- Iterate over items in the current group -->
          @for (item of navItemGroup; track item) {
            <li class="sidebar-item !text-[#48525F]">
              <a
                [routerLink]="'/' + item.link"
                (click)="onItemClick(item)"
                routerLinkActive="active"
                [id]="item.label + 'link'"
                class="flex items-center h-[47px]"
              >
                <i
                  [sch-icon]="item.icon"
                  class="icon !text-2xl !font-medium"
                ></i>
                @if (!isCollapsed) {
                  <span class="ms-2">{{ item.label | titlecase }}</span>
                }
              </a>
            </li>
          }
        }
      </ul>
    </div>

    <div class="sidebar-foot">
      <div class="sidebar-foot__scope">
        <ng-content select="[scope]"></ng-content>
      </div>
      <div class="sidebar-foot__controls">
        <button
          type="button"
          class="sidebar-foot__hub"
          aria-label="Open SEECH hub"
          (click)="launchHub()"
        >
          <i sch-icon="dashboard-circle" aria-hidden="true"></i>
          @if (!isCollapsed) {
            <span>Hub</span>
          }
        </button>
        <button
          type="button"
          class="sidebar-foot__toggle"
          [attr.aria-label]="
            isCollapsed ? 'Expand navigation' : 'Collapse navigation'
          "
          (click)="toggleSidebar()"
        >
          <i [sch-icon]="toggleIcon" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</nav>
